export var DEPLOY_DATE = new Date('2026-05-13T06:49:01+0000');
